module.exports = __webpack_public_path__ + "static/img/huiyuanjianzheng.612e5fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huiyuanjianzheng.jpg
// module id = 4Qgu
// module chunks = 0